import { u as R, a as B, m as i, o as D, b as I, c as s, e as a, g as n, F as T, p as V, x as U, k as l, i as W, t as d, f, n as L } from "./define-element-XpjsV6s1.js";
import { u as q } from "./use-content-CE6lDEIw.js";
import { u as F } from "./use-config-1FCHS5th.js";
import { u as z } from "./use-user-CwEHAZOt.js";
import { _ as E } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const O = {
  ref: "container",
  class: "offset-welcome"
}, P = {
  key: 0,
  class: "carousel mb-5"
}, j = { class: "carousel-inner" }, G = ["src", "alt"], J = { key: 0 }, K = { class: "page-messaging" }, Q = { key: 0 }, X = { key: 0 }, Y = {
  key: 1,
  class: "offset-customer-name customer lead"
}, Z = ["innerHTML"], ee = {
  key: 3,
  class: "signature"
}, te = ["src"], se = {
  key: 0,
  class: "closing"
}, ae = { class: "calls-to-action mt-4 mb-4" }, ne = ["href"], oe = ["href"], le = ["href"], re = {
  key: 2,
  class: "cta"
}, ie = ["href"], ce = ["innerHTML"], ue = {
  __name: "Welcome",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    slug: {
      type: String,
      default: ""
    },
    accountUrl: {
      type: String,
      default: "/account/"
    },
    offeringUrl: {
      type: String,
      default: "/offering/"
    },
    appointmentUrl: {
      type: String,
      default: "/visit/#request"
    }
  },
  setup(g) {
    const p = g, { config: c } = F(), { data: h } = z(), { data: u } = q(p.slug), M = R("container"), m = B(0), _ = i(() => {
      var o, r;
      const e = u.value;
      if (!e) return [];
      if (Array.isArray(e.images)) return e.images;
      const t = [];
      for (let v = 1; v <= 12; v++) {
        const C = e[`image_set_1_img_${v}_large`];
        if (!C) break;
        t.push({
          large: C,
          alt_text: (o = e[`image_set_1_img_${v}_alt_text`]) != null ? o : "",
          caption: (r = e[`image_set_1_img_${v}_caption`]) != null ? r : ""
        });
      }
      return t;
    }), y = i(() => {
      var e, t;
      return (t = (e = u.value) == null ? void 0 : e.title) != null ? t : "";
    }), k = i(() => {
      var e, t;
      return (t = (e = u.value) == null ? void 0 : e.subtitle) != null ? t : "";
    }), b = i(() => {
      var e, t, o, r;
      return (r = (o = (e = u.value) == null ? void 0 : e.lead) != null ? o : (t = c.value) == null ? void 0 : t.message_welcome_01) != null ? r : "";
    }), x = i(() => {
      var e, t, o, r;
      return (r = (o = (e = u.value) == null ? void 0 : e.body) != null ? o : (t = c.value) == null ? void 0 : t.message_welcome_02) != null ? r : "";
    }), S = i(() => {
      var e, t;
      return (t = (e = u.value) == null ? void 0 : e.cta_link) != null ? t : "";
    }), N = i(() => {
      var e, t;
      return (t = (e = u.value) == null ? void 0 : e.cta_text) != null ? t : "";
    }), w = i(() => {
      var t;
      const e = h.value;
      return e ? e.salutation ? `${e.salutation} ${e.last_name}` : (t = e.first_name) != null ? t : "" : "";
    }), A = i(() => {
      var e;
      return !!((e = h.value) != null && e.allocation);
    });
    function $() {
      m.value = (m.value - 1 + _.value.length) % _.value.length;
    }
    function H() {
      m.value = (m.value + 1) % _.value.length;
    }
    return D(() => {
      I(M.value, p.inheritStyle);
    }), (e, t) => (s(), a("div", O, [
      _.value.length ? (s(), a("div", P, [
        n("div", j, [
          (s(!0), a(T, null, V(_.value, (o, r) => (s(), a("figure", {
            key: r,
            class: L(["carousel-item image-set-1 mb-0", { active: r === m.value }])
          }, [
            n("img", {
              class: "d-block w-100",
              src: o.large,
              alt: o.alt_text
            }, null, 8, G),
            o.caption ? (s(), a("figcaption", J, d(o.caption), 1)) : l("", !0)
          ], 2))), 128))
        ]),
        _.value.length > 1 ? (s(), a(T, { key: 0 }, [
          n("a", {
            class: "carousel-control-prev",
            href: "#",
            onClick: U($, ["prevent"]),
            style: { "text-decoration": "none" }
          }, t[0] || (t[0] = [
            n("span", { "aria-hidden": "true" }, "←", -1),
            n("span", { class: "sr-only" }, "Previous", -1)
          ])),
          n("a", {
            class: "carousel-control-next",
            href: "#",
            onClick: U(H, ["prevent"]),
            style: { "text-decoration": "none" }
          }, t[1] || (t[1] = [
            n("span", { "aria-hidden": "true" }, "→", -1),
            n("span", { class: "sr-only" }, "Next", -1)
          ]))
        ], 64)) : l("", !0)
      ])) : l("", !0),
      n("div", K, [
        y.value ? (s(), a("h1", Q, [
          W(d(y.value) + " ", 1),
          k.value ? (s(), a("small", X, d(k.value), 1)) : l("", !0)
        ])) : l("", !0),
        w.value ? (s(), a("div", Y, [
          n("p", null, d(w.value) + ",", 1)
        ])) : l("", !0),
        b.value ? (s(), a("div", {
          key: 2,
          class: "body",
          innerHTML: b.value
        }, null, 8, Z)) : l("", !0),
        f(c).image_checkout_signature ? (s(), a("div", ee, [
          n("img", {
            src: f(c).image_checkout_signature,
            alt: ""
          }, null, 8, te),
          f(c).signature_closing ? (s(), a("div", se, d(f(c).signature_closing), 1)) : l("", !0)
        ])) : l("", !0),
        n("div", ae, [
          A.value ? (s(), a("a", {
            key: 0,
            class: "btn btn-primary",
            href: g.offeringUrl
          }, "Access your Offering", 8, ne)) : l("", !0),
          n("a", {
            class: L(["btn", A.value ? "btn-link" : "btn-primary"]),
            href: g.accountUrl
          }, "Access your Account", 10, oe),
          f(c).enable_appointments_web ? (s(), a("a", {
            key: 1,
            class: "btn btn-link",
            href: g.appointmentUrl
          }, "Request an Appointment", 8, le)) : l("", !0),
          S.value ? (s(), a("span", re, [
            n("a", {
              class: "btn btn-link",
              href: S.value
            }, d(N.value), 9, ie)
          ])) : l("", !0)
        ]),
        x.value ? (s(), a("div", {
          key: 4,
          class: "body",
          innerHTML: x.value
        }, null, 8, ce)) : l("", !0)
      ])
    ], 512));
  }
}, ge = /* @__PURE__ */ E(ue, [["__scopeId", "data-v-e7d1a59f"]]);
export {
  ge as W
};
